import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Fragrances from "../pages/fragrances/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import News from "../pages/news/page";
import Privacy from "../pages/legal/Privacy";
import Legal from "../pages/legal/Legal";
import Cookies from "../pages/legal/Cookies";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/fragrances",
    element: <Fragrances />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/news",
    element: <News />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/legal",
    element: <Legal />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;